var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"divider",style:(("width:" + _vm.width + " ; background:" + _vm.color + " ; height:" + _vm.height))})])}
var staticRenderFns = []

export { render, staticRenderFns }